"use strict";

angular.module("exploitation")

	.controller("itl-managementCtrl", ["$scope", "$uibModal", "Utils", "lines", "ExploitationService", "toastr", "SecurityService", function ($scope, $uibModal, Utils, lines, ExploitationService, toastr, SecurityService) {

		$scope.data = {
			lines: lines.data
		};

		const BoardingAlightingPossibilityEnum = {
			BOARD_AND_ALIGHT: "BoardAndAlight",
			ALIGHT_ONLY: "AlightOnly",
			BOARD_ONLY: "BoardOnly",
			NEITHER_BOARD_OR_ALIGHT: "NeitherBoardOrAlight",
			BOARD_AND_ALIGHT_ON_REQUEST: "BoardAndAlightOnRequest",
			ALIGHT_ON_REQUEST: "AlightOnRequest",
			BOARD_ON_REQUEST: "BoardOnRequest"
		};

		let boardingAlightingEditModal;

		$scope.lineSelected = function () {

			ExploitationService.getDestinations($scope.data.selectedLine.id).then((response) => {
				$scope.data.directions = response.data;
			});
		}


		$scope.directionSelected = function () {

			ExploitationService.getStopAreasItl(
				$scope.data.selectedLine.id,
				$scope.data.selectedDirection.journeyPatternId,
				$scope.data.selectedDirection.wayback
			).then((response) => {
				$scope.data.stopAreas = response.stopAreas.data;
			});
		}

		$scope.getCssStyleBoardingAlighting = (value) => {
			const gradient = $scope.getColorAccordingToEnumPossibilities(value);
			return {
				'background': "linear-gradient(-135deg,"+gradient+")"
			}
		}

		$scope.getColorAccordingToEnumPossibilities = (value) => {
			switch (value) {
				default:
				case BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT:
					return "#5cb85c 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.BOARD_ONLY:
					return "#5cb85c 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.ALIGHT_ONLY:
					return "#d9534f 50%, #5cb85c 50%";
				case BoardingAlightingPossibilityEnum.NEITHER_BOARD_OR_ALIGHT:
					return "#d9534f 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.BOARD_ON_REQUEST:
					return "#f0ad4e 50%, #d9534f 50%";
				case BoardingAlightingPossibilityEnum.ALIGHT_ON_REQUEST:
					return "#d9534f 50%, #f0ad4e 50%";
				case BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT_ON_REQUEST:
					return "#f0ad4e 50%, #f0ad4e 50%";
			}
		};

		const BoardingAlightingPossibilityEnumAndLabels = [
			{
				"label": "Montée et descente autorisées",
				"value": BoardingAlightingPossibilityEnum.BOARD_AND_ALIGHT
			},
			{
				"label": "Descente autorisée uniquement",
				"value": BoardingAlightingPossibilityEnum.ALIGHT_ONLY
			},
			{
				"label": "Montée autorisée uniquement",
				"value": BoardingAlightingPossibilityEnum.BOARD_ONLY
			}
		];

		/**
		 * Ouvre la modal d'édition des autorisations de montée/descente d'un PA
		 * @param $event
		 * @param stopPoint
		 */
		$scope.openBoardingAlightingEditPopup = ($event, stopArea) => {
			$event.stopPropagation();

			if (!SecurityService.hasRight('canEditBoardingAlighting')) {
				return;
			}

			$scope.boardingAlightingEditModal = {
				originalStopArea: stopArea,
				stopArea: angular.copy(stopArea),
				selectValues: BoardingAlightingPossibilityEnumAndLabels
			};
			boardingAlightingEditModal = Utils.openModal($uibModal, "boardingAlightingEdit.html", $scope);
		};

		/**
		 * Valide l'edition des autorisations de montée/descente d'un stop_point
		 */
		$scope.editBoardingAlightingStopPoint = () => {
			const stopArea = $scope.boardingAlightingEditModal.stopArea;
			ExploitationService.updateStopAreaBoardingAndAlighting(stopArea, $scope.data.selectedDirection.wayback)
				.then(() => {
					toastr.success("Autorisations de montée/descente modifiées");
					boardingAlightingEditModal.close();
					$scope.boardingAlightingEditModal.originalStopArea.boardingAlightingPossibility = $scope.boardingAlightingEditModal.stopArea.boardingAlightingPossibility;
				})
				.catch((error) => {
					Utils.makeErrorMessage(error, "Erreur lors de la modification des autorisations de montée/descente");
				});
		};


		$scope.$watch("data.selectedLine", () => {
			if ($scope.data.selectedLine) {
				$scope.lineSelected();
			}
		})

		$scope.$watch("data.selectedDirection", () => {
			if ($scope.data.selectedDirection) {
				$scope.directionSelected();
			}
		})

	}]);